import { DEFAULT_CULTURE_BY_LANGUAGE, isSurfaceLanguage, normalizeCulture, type SurfaceLanguage } from './languages'

export interface LanguageSources {
  readonly preference?: unknown
  readonly cookie?: unknown
  readonly navigatorLanguages: readonly string[]
  readonly fallback: SurfaceLanguage
}

export function resolveLanguage(sources: LanguageSources): SurfaceLanguage {
  for (const value of [sources.preference, sources.cookie]) {
    if (isSurfaceLanguage(value)) return value
  }
  for (const value of sources.navigatorLanguages) {
    const culture = normalizeCulture(value)
    const language = culture?.split('-')[0]
    if (isSurfaceLanguage(language)) return language
  }
  return sources.fallback
}

export interface CultureSources {
  readonly language: SurfaceLanguage
  readonly preferenceCulture?: unknown
  readonly cookieCulture?: unknown
  readonly navigatorLanguages: readonly string[]
}

/** Explicit culture choices are independent of UI language; browser inference follows it. */
export function resolveCulture(sources: CultureSources): string {
  for (const value of [sources.preferenceCulture, sources.cookieCulture]) {
    const culture = normalizeCulture(value)
    if (culture) return culture
  }
  for (const value of sources.navigatorLanguages) {
    const culture = normalizeCulture(value)
    if (!culture) continue
    const locale = new Intl.Locale(culture)
    if (locale.language === sources.language && locale.region) return culture
  }
  return DEFAULT_CULTURE_BY_LANGUAGE[sources.language]
}
